// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"fa61711d","213":"d12803ba","239":"5ee812e2","453":"7d5a8029"}[chunkId] + ".chunk.js";
};